/**
 * Create Listing — Draft Mixin
 *
 * localStorage autosave and restore for in-progress listings.
 *
 * @package Lovasok_Marketplace
 */

const DRAFT_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 nap

export function draftMixin() {
    return {
        draftNotice: '',
        draftAutosaveTimer: null,

        getDraftStorageKey() {
            const suffix = this.isEditing && this.listingId ? `edit_${this.listingId}` : 'new';
            return `lovasok_create_listing_draft_${suffix}`;
        },

        startDraftAutosave() {
            if (this.draftAutosaveTimer) clearInterval(this.draftAutosaveTimer);

            let lastSnapshot = '';
            this.draftAutosaveTimer = window.setInterval(() => {
                const snapshot = JSON.stringify({
                    currentStep: this.currentStep,
                    formData: this.formData,
                    selectedPackageInfo: this.selectedPackageInfo,
                });
                if (snapshot !== lastSnapshot) {
                    this.persistDraft();
                    lastSnapshot = snapshot;
                }
            }, 1500);
        },

        persistDraft() {
            try {
                localStorage.setItem(this.getDraftStorageKey(), JSON.stringify({
                    savedAt:            Date.now(),
                    currentStep:        this.currentStep,
                    listingMode:        this.listingMode,
                    formData:           this.formData,
                    selectedPackageInfo: this.selectedPackageInfo,
                }));
            } catch (e) {
                console.warn('Draft save failed:', e);
            }
        },

        restoreDraft() {
            try {
                const raw = localStorage.getItem(this.getDraftStorageKey());
                if (!raw) return;

                const draft = JSON.parse(raw);
                if (!draft?.savedAt || (Date.now() - Number(draft.savedAt)) > DRAFT_MAX_AGE_MS) {
                    localStorage.removeItem(this.getDraftStorageKey());
                    return;
                }

                // Régi piszkozat (listingMode nélkül) → töröljük
                if (!draft.listingMode) {
                    localStorage.removeItem(this.getDraftStorageKey());
                    return;
                }

                if (draft.formData && typeof draft.formData === 'object') {
                    this.formData = { ...this.formData, ...draft.formData };
                }

                this.listingMode = draft.listingMode;

                if (draft.currentStep >= 1 && draft.currentStep <= this.totalSteps) {
                    this.currentStep = Number(draft.currentStep);
                }

                this.selectedPackageInfo = draft.selectedPackageInfo || this.selectedPackageInfo;
                this.draftNotice = 'Piszkozat visszaállítva — a feltöltött képek újra kiválasztandók.';
            } catch (e) {
                console.warn('Draft restore failed:', e);
            }
        },

        clearDraft() {
            try {
                localStorage.removeItem(this.getDraftStorageKey());
            } catch (e) {
                console.warn('Draft clear failed:', e);
            }
        },

        dismissDraftNotice() {
            this.draftNotice = '';
        },
    };
}
